import * as mutation_types from "./mutation_types";

export default {
    [mutation_types.M_SET_TOUR_INFO](state, payload) {
        state.tour = payload;
    },
    [mutation_types.M_SET_GDS_PARAM](state, payload) {
        state.GDSParam = payload;
    },
    [mutation_types.M_SET_API_URL](state, payload) {
        state.API_URL = payload;
    },
    [mutation_types.M_SET_API_ORIGIN](state, payload) {
        state.API_ORIGIN = payload;
    },
    [mutation_types.M_SET_HOTELS_FOR_MAP](state, payload) {
        state.mapItems = [...payload]
    },
    [mutation_types.M_SET_AGREE_TO_RECEIVE](state, payload) {
        state.iAgreeToReceive = payload;
    },
};
